export type RuntimeConfig = {
  apiToken?: string;
  apiBaseUrl?: string;
  identityApiBaseUrl?: string;
  identityLoginUrl?: string;
  mediaCdnUrl?: string;
  publicFormsBaseUrl?: string;
};

export function readRuntimeConfig(): RuntimeConfig {
  if (typeof window === "undefined") return {};
  return window.__CHMFORMS_CONFIG__ ?? {};
}
